export enum DrawType {
  farmland_polygon = 'farmland_polygon',
  drawn_area = 'drawn_area',
  unaccounted_areas = 'unaccounted_areas',
  error_area = 'error_area',
  reprocess_area = 'reprocess_area',
  worked_area = 'worked_area',
  distance_line = 'distance_line',
}

export type MarkerDto = {
  id: number;
  position: [number, number];
  popup: {
    html: string;
  };
  status?: 'online' | 'offline';
};
